import { useEffect, useState } from 'react';

function verifyRedirect() {
  if (typeof window === 'undefined') {
    return null;
  }

  const currentSearch = window.location.search;

  return currentSearch;
}

const ManagedTrans = () => {
  const [pathURL, setPathURL] = useState(null);

  useEffect(() => {
    const searchInfo = verifyRedirect();
    if (searchInfo) {
      setPathURL('/shipper/managed-transportation/' + searchInfo);
      window.location.href = pathURL;
    } else {
      window.location.href = '/shipper/managed-transportation/';
    }
  }, [pathURL]);
  return <div />;
};

export default ManagedTrans;
